const utils = require('../../../lib/utils')

module.exports = {
	model: {
		// config: {
		// 	fields: {
		// 		copyToClipboard: true, // should the copyToClipboard-Button be shown
		// 	}
		// }
	},

	events: {
		copyToClipboard: {
			type: 'click',
			selector: 'button',
			action: async event => {
				const fieldType = $(event.target).closest('button').data('fieldType')

				if(fieldType === 'copyToClipboard'){
					event.stopImmediatePropagation()

					const self = event.data.component
					const $input = self.$.find('textarea')
					const value = $input.val()

					const success = await utils.copyToClipboard(value)
				}
			}
		}
	},
}